const initalState = {
    products: [{
        type: '',
        name: '',
        price: '',
        quantity: '',
        equal: '',
        amortization: ''
    }]
}

export const products = (state = initalState.products, action) => { 
    switch (action.type) {
        case 'SET_PRODUCTS':
            return action.value;      
        default:
            return state
    }
}